import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function normalizeProductImageSource(value) {
  const source = typeof value === 'string' ? value.trim() : '';
  if (!source) return '';

  if (/^https?:\/\//i.test(source)) {
    try {
      const url = new URL(source);
      if (url.hostname === 'instagram.com' || url.hostname.endsWith('.instagram.com')) return '';
      return url.toString();
    } catch {
      return '';
    }
  }

  const path = source.replace(/\\/g, '/');
  const publicPathIndex = path.toLowerCase().lastIndexOf('/public/');
  if (publicPathIndex >= 0) return encodeURI(path.slice(publicPathIndex + '/public'.length));
  if (/^[a-z]:\//i.test(path)) return '';

  const publicPath = path.startsWith('public/')
    ? `/${path.slice('public/'.length)}`
    : path.startsWith('/') ? path : `/${path}`;
  try {
    return encodeURI(decodeURI(publicPath));
  } catch {
    return encodeURI(publicPath);
  }
}
